import script from "./UnreadSmsEmailLogstResultTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnreadSmsEmailLogstResultTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./UnreadSmsEmailLogstResultTemplate.vue?vue&type=style&index=0&id=08167dbc&scoped=true&lang=scss"
import "./UnreadSmsEmailLogstResultTemplate.vue?vue&type=style&index=1&id=08167dbc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08167dbc"]])

export default __exports__